<template>
  <div
    v-if="props.author"
    :class="!props.isDetail ? 'badge--article-card' : ''"
    class="badge"
  >
    <div class="badge__aside">
      <img
        loading="lazy"
        v-if="props.author?.imageUrlWithProtocol && !imageError"
        class="object-cover h-full w-full"
        :src="props.author?.imageUrlWithProtocol"
        :alt="props.author?.name || ''"
        width="60"
        height="60"
        @error="replaceByDefault"
      >
      <!--no profile-pic -->
      <DefaultIconsAccount v-if="!props.author?.imageUrlWithProtocol || imageError" />
      <!--no profile-pic -->
    </div>

    <div
      class="badge__body"
    >
      <NuxtLink
        v-if="props.author.id"
        :to="getAuthorDetailPath()"
        class="badge__author-name"
      >
        {{ props.author?.name }}
      </NuxtLink>
      <span v-else class="badge__author-name">
        {{ props.author?.name }}
      </span>
      <div class="flex gap-2">
        <span v-if="props.published">{{ dateFormat.getFormatedDate(props.published) }}</span>
        <span v-if="props.published">{{ dateFormat.getFormatedTime(props.published) }}</span>
        <DefaultArticlesArticleTag />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type {Maybe} from "@graphql-tools/utils"
import type SimpleAuthor from "~/libs/interfaces/SimpleAuthor"
import type {PropType} from "vue"
import {useAuthorUrl} from "~/composables/useAuthorUrl"

const dateFormat = useDate()


const props = defineProps({
  author: {type: Object as PropType<Maybe<SimpleAuthor>>, required: false},
  isDetail: {type: Boolean, required: false, default: false},
  published: {type: Date, required: false}
})

const localePath = useLocalePath()

const imageError = ref(false)

const replaceByDefault = () => {
  imageError.value = true
}

const getAuthorDetailPath = () => {
  return localePath({ name: 'authors-authorUrl', params: { authorUrl: useAuthorUrl(props.author?.id, props.author?.name) } })
}

</script>

<style lang="postcss" scoped>

</style>
